import { Dialog } from '@carto/meridian-ds/components'
import { BaseDialogProps } from 'features/dialogs/types'
import { Video } from '../types'

export interface OnboardingChecklistVideoDialogProps extends BaseDialogProps {
  video: Video
  autoPlay?: boolean
}

const WORKSPACE_VIDEO_URL = 'https://app-gallery.cartocdn.com/onboarding_assets/workspace-video.mp4'
const BUILDER_VIDEO_URL = 'https://app-gallery.cartocdn.com/onboarding_assets/builder-video.mp4'
const WORKFLOWS_VIDEO_URL = 'https://app-gallery.cartocdn.com/onboarding_assets/workflows-video.mp4'
const AIAGENT_VIDEO_URL = 'https://app-gallery.cartocdn.com/onboarding_assets/aiagent-video.mp4'
const AGENTICGISBUILDER_VIDEO_URL = 'https://app-gallery.cartocdn.com/onboarding_assets/agenticgis-video.mp4'

function OnboardingChecklistVideoDialog({
  video,
  autoPlay = true,
  onClose,
  ...dialogProps
}: OnboardingChecklistVideoDialogProps) {
  const videoSources: { [key in Video]: string } = {
    [Video.WORKSPACE]: WORKSPACE_VIDEO_URL,
    [Video.BUILDER]: BUILDER_VIDEO_URL,
    [Video.WORKFLOWS]: WORKFLOWS_VIDEO_URL,
    [Video.AIAGENT]: AIAGENT_VIDEO_URL,
    [Video.AgenticGISBuilder]: AGENTICGISBUILDER_VIDEO_URL
  }

  return (
    <Dialog size="xlarge" onClose={onClose} {...dialogProps} height="auto">
      <video width="100%" height="100%" controls src={videoSources[video]} autoPlay={autoPlay}>
        Your browser does not support the video tag.
      </video>
    </Dialog>
  )
}

export default OnboardingChecklistVideoDialog
